export const PASSWORD_MIN_LENGTH = 8;

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^\+?[1-9]\d{7,14}$/;

export function normalizeEmail(value = "") {
  return String(value).trim().toLowerCase();
}

export function normalizePhone(value = "") {
  const trimmed = String(value).trim();
  if (!trimmed) return "";

  const stripped = trimmed.replace(/[\s\-()]/g, "");
  const withPrefix = stripped.startsWith("+") ? stripped : `+${stripped}`;
  return withPrefix;
}

export function isValidEmail(value = "") {
  return emailRegex.test(normalizeEmail(value));
}

export function isValidPhone(value = "") {
  if (!value) return false;
  return phoneRegex.test(normalizePhone(value));
}

export function validatePasswordStrength(password = "") {
  const raw = String(password);
  const checks = {
    minLength: raw.length >= PASSWORD_MIN_LENGTH,
    uppercase: /[A-Z]/.test(raw),
    lowercase: /[a-z]/.test(raw),
    number: /\d/.test(raw),
    symbol: /[^A-Za-z0-9]/.test(raw),
  };

  const passed = Object.values(checks).filter(Boolean).length;

  return {
    checks,
    score: passed,
    isStrong: checks.minLength && checks.uppercase && checks.lowercase && checks.number && checks.symbol,
  };
}

export function getPasswordStrengthLabel(score = 0) {
  if (score <= 1) return "Weak";
  if (score <= 3) return "Fair";
  if (score === 4) return "Good";
  return "Strong";
}
